/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export const getMessage = (data) => {
  const linkContent = data?.split(/\r?\n/); // all links

  return linkContent?.shift(); // message
};

export const getLinks = (data) => {
  let links = [];
  const linkContent = data?.split(/\r?\n/); // all links
  linkContent?.shift(); // remove message

  // separate link title and url
  linkContent?.forEach((link) => {
    links.push(link.split('---'));
  });

  return links.filter((link) => link[0] !== '');
};
